export var IndexFormat;
(function (IndexFormat) {
    IndexFormat[IndexFormat["UInt8"] = 0] = "UInt8";
    IndexFormat[IndexFormat["UInt16"] = 1] = "UInt16";
    IndexFormat[IndexFormat["UInt32"] = 2] = "UInt32";
})(IndexFormat || (IndexFormat = {}));
